import { fieldNames } from '../../config/form';
import { modalContentTypes } from '../../config/modalContent';

const isValuesEmpty = (values) => !values || Object.keys(values).length === 0;

export const transformValues = {
  [modalContentTypes.invoiceAndTypes]: (values = {}) => {
    if (isValuesEmpty(values)) return null;

    const priceData = values[fieldNames.priceData];
    const paymentTypes = values[fieldNames.paymentTypes];

    const { price, isNotFinal } = priceData;

    const data = {
      price: {
        sum: price * 100,
        isFinal: !isNotFinal,
      },
    };

    if (!isNotFinal && paymentTypes?.length) {
      data.paymentTypesData = { paymentTypes };
    }

    return data;
  },

  [modalContentTypes.typesAndState]: (values) => {
    if (isValuesEmpty(values) || !values[fieldNames.paymentState]) return null;

    return { data: values };
  },
};
